import React from "react";

let TechPulse = React.createClass({
    getInitialState() {
        return {};
    },
    render() {
        return (
            <div className={["eo-tech-pulse", this.props.className].join(" ")}>
                    <div className="eero-pulse">
                        <img src="/public/img/technology/eero-topdown.png" className="eero-device"/>
                    </div>
            </div>
        );
    }
});

export default TechPulse;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/technology/components/TechPulse.js
 **/